// @ts-nocheck
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import React, {useEffect} from 'react';
import AbroadPackageClientData from '../../../Models/Content/AbroadMarketPopularBlockData';
import AbroadPackagesPopular from '../CellcomAbroadLobbyBlock/Shared/Components/AbroadPackagesPopular';
import {prepareUrl ,getDataFromIContentRepo ,buildUrlAndNavigate} from '../../../utilities/StringHelpers/StringHelpers.js';
import {setActiveLobbyTab, setSelectedAbroadPackage, updateTicketFromPackageManager, getCustomerCellularList} from '../../Block/CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice.js';
import {lobbyTabsEnum, customerTypeEnum} from '../../Block/CellcomAbroadLobbyBlock/cellcomAbroadVariables.js';
import {connect} from 'react-redux';
import {
  AbroadPackageClientState,
  AbroadPackageModel,
  ClientType,
  PackageOrigin,
} from '../CellcomAbroadLobbyBlock/Shared/Models/AbroadPackageModels';
import SubMainHeadlineComponent from '../CellcomAbroadLobbyBlock/SubMainHeadLineComponent';
import {isMobile} from 'react-device-detect';
import {Container} from 'reactstrap';
import {dwhAbroadAddonPackagePage} from '../CellcomAbroadLobbyBlock/dwhReports';
import Config from 'app/Config';

interface SelectedSubscriber {
  selectedFamilyReducedSoc?: string;
  abroadPackages?: {regularPackages?: any};
}
interface AbroadDataProps {
  context: IEpiserverContext;
  props: AbroadPackageClientData;
  setActiveLobbyTab: Function;
  setSelectedAbroadPackage: Function;
  cellcomAbroad: AbroadPackageClientState;
  userData: any;
  mobile: string;
  loginData: {isFullAuthenticated?: boolean, isOtpExtendedAuthenticated?: boolean};
  updateTicketFromPackageManager: Function;
  getCustomerCellularList: Function;
  selectedSubscriber?: SelectedSubscriber;
}

const AbroadMarketPopularMain = (props: AbroadDataProps) => {
  const clientType = props.props.clientType?.value;

  const reducedSocsBlockId = getDataFromIContentRepo('linkForReducedPackages')?.id;
  const linkForAbroadTicket = Config.staticWebSiteUrl + getDataFromIContentRepo('linkForAbroadTicket')?.url;

  const convertClientTypeToLobbyTabsEnum = (clientTypeNumber: number) => {
    if (clientTypeNumber === 0) return lobbyTabsEnum.PRIVATE;
    else if (clientTypeNumber === 1) return lobbyTabsEnum.BUSINESSACCOUNT;
  };
  const convertClientTypeToClientTypeEnum = (clientTypeNumber: number) => {
    if (clientTypeNumber === 0) return ClientType.PRIVATE;
    else if (clientTypeNumber === 1) return ClientType.BUSINESS;
  };

  const requestPackagePopular = React.useMemo(() => {
    return {
      socIdList: props.props.packagesList.expandedValue.map((value: any) => value.sockCode.value) as string[],
      blockId: props.props.lobbyFolderReference.value.id,
      clientType: convertClientTypeToClientTypeEnum(clientType),
    };
  }, [props.props.packagesList.expandedValue, props.props.lobbyFolderReference.value.id, clientType]);
  const pageBlockId = props.context?.getRoutedContent()?.contentLink?.id;
  const queryUrl = `?blockId=${props.props.lobbyFolderReference.value.id}?clientType=${convertClientTypeToClientTypeEnum(clientType)}`;

  const dwhParams = {
    channel:
      props.cellcomAbroad?.activeLobbyTab && props.cellcomAbroad?.activeLobbyTab == 'businessAccount' ? 'WebsiteBusiness' : 'WebsitePrivate',
    param1: props.cellcomAbroad?.isJETAuthentication ? 'JET' : 'WEBSITE',
    actionType: 'Addon Package Page',
    costumerName: props.userData?.firstName + ' ' + props.userData?.lastName,
    idNumber: props.userData?.IDNumber,
    subscriber: props.mobile,
  };

  const urlToExtendedPackages =
    props.cellcomAbroad?.otpData?.validatedCostumerData?.accountType == customerTypeEnum.PRIVATE
      ? props.cellcomAbroad?.epiStyleInitializationData?.pageRefToExtendedPackagesPrivate
      : props.cellcomAbroad?.epiStyleInitializationData?.pageRefToExtendedPackagesBusiness;

  useEffect(() => {
    if (urlToExtendedPackages) {
      dwhAbroadAddonPackagePage({
        message: 'Addon Package Page Displayed',
        ...dwhParams,
      });
    }
  }, []);

  function getRightDateArr(dateArr) {
    const secondDate = new Date(parseInt(dateArr[2]), parseInt(dateArr[1]) - 1, parseInt(dateArr[0]));
    const today = new Date();
    if (today.getTime() > secondDate.getTime()) return [today.getDate(), today.getMonth() + 1, today.getFullYear()];
    else return [dateArr[0], dateArr[1], dateArr[2]];
  }

  const orderEvent = async (packageData: AbroadPackageModel) => {
    
    props.setActiveLobbyTab(convertClientTypeToLobbyTabsEnum(clientType));
    props.setSelectedAbroadPackage({
      selectedPackage: packageData,
      folderType: convertClientTypeToClientTypeEnum(clientType),
      startedFromPackage: true,
      selectedOnSalePageFlag: true,
    });
    
    
    if (urlToExtendedPackages) {
      dwhAbroadAddonPackagePage({
        message: 'Addon Package Buy Button Clicked',
        param2: props.cellcomAbroad?.selectedAbroadPackage?.socCode,
        ...dwhParams,
      });
    }
    
    if (reducedSocsBlockId == pageBlockId) {
      const parentRelatedSoc = props.selectedSubscriber?.abroadPackages?.regularPackages?.find(
        (pack) => pack.socName.trim() == props.selectedSubscriber?.selectedFamilyReducedSoc,
      );

      let datePickerStartJSFormat;
      let correctSelectedStartDate;
      let parentStartDate;

      if (parentRelatedSoc?.effDateILLocalTime) {
        const tempDatePickerStartJSFormat = parentRelatedSoc.effDateILLocalTime.split('.');
        const correctDateArray = getRightDateArr(tempDatePickerStartJSFormat);
        datePickerStartJSFormat = [correctDateArray[1], correctDateArray[0], correctDateArray[2]].join('/');
        correctSelectedStartDate = [correctDateArray[0], correctDateArray[1], correctDateArray[2]].join('.');
        parentStartDate = [tempDatePickerStartJSFormat[1], tempDatePickerStartJSFormat[0], tempDatePickerStartJSFormat[2]].join('/');
      } else {
        datePickerStartJSFormat = props.cellcomAbroad?.dates?.datePickerStartJSFormat;
        correctSelectedStartDate = props.cellcomAbroad?.dates?.selectedStartDate;
        parentStartDate = props.cellcomAbroad?.dates?.datePickerStartJSFormat;
      }

      const objToUpdateTicket = {
        selectedPackage: packageData,
        folderType: customerTypeEnum.PRIVATE,
        selectedStartDate: correctSelectedStartDate,
        datePickerStartJSFormat,
        parentStartDate,
        countryList: packageData?.countrySupportedList,
        socCodeParent: props.selectedSubscriber?.selectedFamilyReducedSoc || props.cellcomAbroad?.selectedAbroadPackage?.socCode,
      };
      if (
        (props.loginData?.isFullAuthenticated || props.loginData?.isOtpExtendedAuthenticated) &&
        !props.cellcomAbroad.isJETAuthentication &&
        props.cellcomAbroad.relatedPhoneNumbers.length == 0
      ) {
        await props.getCustomerCellularList();
      }
      await  props.updateTicketFromPackageManager(objToUpdateTicket);
       buildUrlAndNavigate(linkForAbroadTicket);
    }else{
      prepareUrl(props.props.lobbyFolderReference.value.url, props.context, queryUrl);
    }
  };

  const navigateHandleClick = async (event: React.MouseEvent<HTMLDivElement>) => {
    await props.setActiveLobbyTab(convertClientTypeToLobbyTabsEnum(clientType));
    props.context.navigateTo(props.props.lobbyFolderReference.value.url);
  };

  return (
    <div className={`abroad-market-popular mb-5 pb-5 ${isMobile ? `isMobile mt-3 pt-3` : `mt-5 pt-5`}`}>

      <Container style={{marginBottom: isMobile ? '50px' : '70px'}}>
        <SubMainHeadlineComponent title={props.props.titleMarketPopularDesktop.value} />
      </Container>

      <AbroadPackagesPopular
        id={props.props.contentLink.id}
        requestPackagePopular={requestPackagePopular}
        orderEvent={orderEvent}
        context={props.context}
        isPopularMarketOrLobby={PackageOrigin.POPULAR_MARKET}
      />
      {props.props?.buttonText?.value && (
        <div className='abroad-market-popular__primaryContainerButtonBlock'>
          <div className='abroad-market-popular__primaryContainerButtonBlock__secondaryContainerButtonBlock'>
            <div className='abroad-market-popular__primaryContainerButtonBlock__secondaryContainerButtonBlock__buttonBlock'>
              <div
                className='abroad-market-popular__primaryContainerButtonBlock__secondaryContainerButtonBlock__buttonBlock__button'
                onClick={navigateHandleClick}>
                {props.props?.buttonText?.value}
              </div>
              <div className='abroad-market-popular__primaryContainerButtonBlock__secondaryContainerButtonBlock__buttonBlock__arrow'>»</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = ({cellcomAbroad, authentication, selfcarePage}: {
  cellcomAbroad: AbroadPackageClientState;
  selfcarePage: {selectedSubscriber?: SelectedSubscriber};
}) => ({
  cellcomAbroad,
  userData: authentication?.loginData?.userDetails,
  loginData: authentication?.loginData,
  mobile: cellcomAbroad?.epiStyleInitializationData?.businessIndividualLobby
    ? cellcomAbroad?.businessIndividualData?.selectedAccountNumber
    : cellcomAbroad?.otpData?.otpPhone || authentication?.loginData?.userDetails?.contactNumber,
  selectedSubscriber: selfcarePage.selectedSubscriber,
});

export default connect(mapStateToProps, {
  setActiveLobbyTab,
  setSelectedAbroadPackage,
  updateTicketFromPackageManager,
  getCustomerCellularList
})(AbroadMarketPopularMain);
